
import React, {useEffect} from 'react';
import TabConfig from "./tabconfig/tabconfig";
import {useLocation, useParams} from "react-router-dom";
import DashboardNavbar from "../../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";

const AllControlConfig  = () => {

    const { controlSlNo } = useParams();
    const location = useLocation();
    const rowData = location.state?.item;

    useEffect(() => {
        console.log(controlSlNo);
        if (rowData) {
            console.log("Received row data:", rowData);
        }
    }, [rowData]);

    return (
        <>
            <DashboardLayout>
                <DashboardNavbar />
                <TabConfig selectedRowData = {rowData}/>
            </DashboardLayout>
        </>
    );
}
export default AllControlConfig;
